import { Component, Input } from '@angular/core';
import { MxBaseComponent } from 'src/app/core/base/mx.base-component';
import { MxTableColumn } from 'src/app/shared/domains/common/interfaces';

@Component({ standalone: false,
  selector: '[mx-table-loading-body]',
  templateUrl: './mx.table-loading-body.component.html',
  styleUrls: ['./mx.table-loading-body.component.scss'],
})
export class MxTableLoadingBodyComponent extends MxBaseComponent {
  @Input() columns: MxTableColumn[];
  @Input() columnDefaultWidth: number;
}
